import Vue from 'vue';
import Glide from '@glidejs/glide';
import { gsap } from 'gsap';

Vue.component('page-slider', {
    data() {
        return {
            currentSlide: 1,
            glide: null
        }
    },

    mounted() {
        if (document.querySelector('.glide--pageslider') !== null) {
            this.initSlider();
        }

        EventBus.$on('window-resize', this.checkSlider);
    },

    methods: {
        nextSlide() {

            gsap.fromTo('.page-slider__slide-image', {translateY: '0%'}, {translateY: '-100%', duration: 0.8, ease: "power2.out"})
            gsap.set('.page-slider__slide-image', {translateY: '100%', duration: 0, delay: 0.8})

            gsap.delayedCall( 0.8, () => {
                this.glide.go('>') 
            })
            gsap.to('.page-slider__slide-image', {translateY: '0%', duration: 0.8, ease: "power2.out", delay: 0.8})
        },

        previousSlide() {
            gsap.fromTo('.page-slider__slide-image', {translateY: '0%'}, {translateY: '100%', duration: 0.8, ease: "power2.out"})
            gsap.set('.page-slider__slide-image', {translateY: '-100%', duration: 0, delay: 0.8})

            gsap.delayedCall( 0.8, () => {
                this.glide.go('<') 
            })
            gsap.to('.page-slider__slide-image', {translateY: '0%', duration: 1, ease: "power2.out", delay: 0.8})
        },

        initSlider() {
            this.glide = new Glide('.glide--pageslider', {
                type: 'carousel',
                startAt: 0,
                gap: 0,
                peek: 0,
                perView: 1,
                animationDuration: 0,
                swipeThreshold: false,
                dragThreshold: false
            })

            this.glide.on('move.after', (event) => {
                this.currentSlide = this.glide.index + 1;
            });

            this.glide.mount();
        },

        checkSlider() {
            if (this.glide) {
                this.glide.update({ startAt: 0 });
            }
        }
    }
});
